export enum STATUS {
    UNFETCHED,
    LOADING,
    FETCHED,
    ERROR
}